import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./taskItem.html";
/*
 * Example task item: https://appexchange.oaestaging1.com/collections/task-item-test
 */
class TaskItem extends LightningElement {
  constructor(...args) {
    super(...args);
    this.postId = void 0;
    this.taskId = void 0;
    this.uid = void 0;
    this.title = void 0;
    this.subtitle = void 0;
    this.ctaText = void 0;
    this.ctaLink = void 0;
    this.ctaNewTab = void 0;
    this.taskDoneText = void 0;
    this.toggleText = void 0;
    this.hasBadge = void 0;
    this._isComplete = false;
    this._isOpen = true;
    this.store = localStorage;
    this.currentStore = [];
  }
  get isComplete() {
    return this._isComplete;
  }
  set isComplete(value) {
    this._isComplete = value;
  }
  get isOpen() {
    return this._isOpen;
  }
  set isOpen(value) {
    this._isOpen = value;
  }
  get storeKey() {
    return `task-item-${this.postId}`;
  }
  get displayBadge() {
    return this.hasBadge === 'true';
  }
  get hasCta() {
    return this.ctaText && this.ctaLink;
  }
  get hasSubtitle() {
    return this.subtitle?.length;
  }
  get taskItemClass() {
    let className = 'axwp-task-item';
    if (this.isComplete) {
      className += ' is-complete';
    }
    return className;
  }
  get contentClass() {
    let className = 'axwp-task-item__content-wrap';
    if (!this.isOpen) {
      className.replace('is-open', '');
    } else if (!this.isComplete || this.isOpen) {
      className += ' is-open';
    }
    return className;
  }
  connectedCallback() {
    // Load the task completion state from local storage
    this.getStore();
    this._isComplete = this.currentStore.includes(this.uid);
    this._isOpen = !this._isComplete; // If the task is complete, it should not be open by default
  }

  /**
   * Toggle the open state of the task item.
   */
  toggleOpen() {
    this._isOpen = !this.isOpen;
  }

  /**
   * Mark the task as complete.
   */
  markComplete() {
    // If the task is not already complete, close the task item.
    // If the markComplete method is called while already complete, it does not change the open state.
    if (!this.isComplete) {
      this._isOpen = false;
    }
    this._isComplete = true;
    this.updateStore();
  }

  /**
   * Get the current store from local storage.
   * If the store does not exist, initialize it as an empty array.
   */
  getStore() {
    // Parse the store and set the current store
    const storedData = this.store.getItem(this.storeKey);
    if (!storedData) {
      this.currentStore = [];
      return;
    }

    // If the store exists, parse it and set the current store
    this.currentStore = JSON.parse(this.store.getItem(this.storeKey));
  }

  /**
   * Update the local storage with the current task completion state.
   * If the task is complete, add the uid to the store; otherwise, remove it.
   */
  updateStore() {
    this.getStore();
    if (this.isComplete) {
      if (!this.currentStore.includes(this.uid)) {
        // Add the uid to the store
        this.currentStore.push(this.uid);
      }
    }

    // Update local storage
    this.store.setItem(this.storeKey, JSON.stringify(this.currentStore));
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(TaskItem, {
  publicProps: {
    postId: {
      config: 0
    },
    taskId: {
      config: 0
    },
    uid: {
      config: 0
    },
    title: {
      config: 0
    },
    subtitle: {
      config: 0
    },
    ctaText: {
      config: 0
    },
    ctaLink: {
      config: 0
    },
    ctaNewTab: {
      config: 0
    },
    taskDoneText: {
      config: 0
    },
    toggleText: {
      config: 0
    },
    hasBadge: {
      config: 0
    },
    isComplete: {
      config: 3
    },
    isOpen: {
      config: 3
    },
    storeKey: {
      config: 1
    },
    taskItemClass: {
      config: 1
    },
    contentClass: {
      config: 1
    }
  },
  publicMethods: ["toggleOpen", "markComplete"],
  fields: ["_isComplete", "_isOpen", "store", "currentStore"]
});
const __lwc_component_class_internal = _registerComponent(TaskItem, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;